module.exports = __webpack_public_path__ + "images/8ec167c0305be46a80d955d2d5c6be3e.gif";